import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  useTheme,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTenant } from "../../contexts/TenantContext";
import { tint } from "../../utils/textStyles";

// The dialog used to be white paper with black text whatever the tenant looked like, which
// on the dark theme was a page-bright rectangle. It takes the tenant's section colour now,
// the same surface every card on the page is drawn on.
const CancelBookingDialog = ({ open, onClose, onConfirm }) => {
  const { displayConfig } = useTenant();
  const theme = useTheme();
  const textColor = displayConfig?.color;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          px: 1,
          py: 0.5,
          color: textColor,
          backgroundColor: displayConfig?.sectionBackground,
          backgroundImage: "none",
          backdropFilter: "blur(8px)",
          border: `1px solid ${tint(theme.palette.error.main, 0.3)}`,
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, fontWeight: 700 }}>
        <WarningAmberIcon sx={{ color: theme.palette.error.main }} />
        Foglalás lemondása
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ color: tint(textColor, 0.75) }}>
          Biztosan lemondod ezt a foglalást? A művelet nem vonható vissza.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: tint(textColor, 0.75) }}>
          <Typography textTransform="none" fontWeight={600}>Mégse</Typography>
        </Button>

        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            borderRadius: 2,
            backgroundColor: theme.palette.error.main,
            "&:hover": { backgroundColor: theme.palette.error.dark },
          }}
        >
          <Typography textTransform="none" fontWeight={700}>Lemondás</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelBookingDialog;
